/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

const green = '#00c297';
const blue = '#1ba7ff';
const yellow = '#fabe48';
const red = '#ff494e';

/**
 * Standard application's colors usable from the TypeScript code, and registered as Vuetify colors
 * usable in templates (see vuetifyPresets.ts).
 */
export const colors = {
  primary: green,
  warning: yellow,
  error: red,
  links: blue,
  grayIcons: '#bdbdbd',
  darkGrayIcons: '#757575',
  expiredStates: red,
  greyCardBackground: '#f2f2f2',
  grayBackground: '#f7f7f7',
  yellowBackground: '#fff7e6',
  errorBackground: '#ffebec',
  colorEvaluation: blue,
  colorCommercial: green,
  colorOtherLicenses: yellow
};

/**
 * Standard colors that have the rgba(...) format. They are not included into the `colors` hash
 * above, since the `colors` hash is registered as Vuetify colors, and Vuetify doesn't support
 * rgba colors, see here:
 *  - https://stackoverflow.com/questions/57411414/vuetifyjs-how-to-set-custom-rgba-color
 *  - https://v15.vuetifyjs.com/en/framework/theme/#customizing
 */
export const rgbaColors = {
  infoIcons: 'rgba(0, 0, 0, 0.38)'
}
